import React, { Component } from "react";
import { connect } from "react-redux";
import Headroom from "react-headroom";

class PageHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      logoError: false
    };
  }

  handleToggleHeader = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  handleLogoError = () => {
    this.setState({ logoError: true });
  };

  render() {
    const {
      tenant,
      displayPhoneNumber,
      customerTermsUrl,
      customerPrivacyPolicyUrl
    } = this.props;
    return (
      <Headroom style={{ zIndex: 9999 }}>
        <div className="navbar">
          <div
            className={`header-container ${this.state.isOpen ? "open" : ""}`}
          >
            <div className="header-logo">
              {tenant ? (
                <img
                  src={`/${tenant}/api/portalsettings/LogoImage`}
                  alt="clinic logo"
                  onError={this.handleLogoError}
                />
              ) : null}
            </div>
            <div className="header-right">
              <div className="header-contact">
                <span className="header-contact-label">
                  Can't find the time you want?
                </span>
                <span className="header-contact-number">
                  {displayPhoneNumber}
                </span>
              </div>
              <nav className="header-nav">
                <ul className="nav list-inline">
                  <li>
                    <span>Powered by coreplus</span>
                  </li>
                  <li>
                    <a
                      href="http://coreplus.com.au/about-us/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      About coreplus
                    </a>
                  </li>
                  <li>
                    <a href={customerTermsUrl} target="_blank">
                      Terms & Condition
                    </a>
                  </li>
                  <li>
                    <a href={customerPrivacyPolicyUrl} target="_blank">
                      Privacy Policy
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
            <i
              className="material-icons btn-header-icon"
              onClick={this.handleToggleHeader}
            >
              info_outline
            </i>
          </div>
        </div>
      </Headroom>
    );
  }
}

const mapStateToProps = ({ config }) => {
  return { ...config };
};

export default connect(
  mapStateToProps,
  {}
)(PageHeader);



// WEBPACK FOOTER //
// ./src/modules/Layout/components/PageHeader.js